<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="add_number">
      {{ $t('call-tracking.button.create') }}
    </i-button>

    <filter-component />
    <table-component />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';
  import FilterComponent from '@call-tracking/components/numbers-list-table-filter';
  import TableComponent from '@call-tracking/components/numbers-list-table';
  import { NumberModalService } from '@call-tracking/modals/NumberModalService';

  export default {
    components: { FilterComponent, TableComponent },
    methods: {
      ...mapActions('call-tracking/numbers/table', ['getAsyncData']),

      add_number: function() {
        NumberModalService.create().on('success', () => this.getAsyncData());
      }
    }
  };
</script>
